import { animationCSS, bgCSS, shadowCSS } from "./CssHelper";
import { applyListFunctions } from "./DynamicValueResolver";
import { T } from "./exports";
import { LeafView } from "./LeafRenderer";
import { ResizeHandles } from "./ResizeHelper";

export function GroupView({node,myPath,selPath,onSelect,onDragStart,onResizeStart,dataCtx,previewData,runtimeVars,onVarChange,globalSourceStore}){
  const s=node.styles;
  const isSel=selPath&&selPath.length===myPath.length&&myPath.every((id,i)=>selPath[i]===id);
  const isAnc=selPath&&selPath.length>myPath.length&&myPath.every((id,i)=>selPath[i]===id);
  const overflowCSS=s.overflow==="hidden"?"hidden":s.overflow==="scroll"?"auto":"visible";
  const hideScrollbar=s.overflow==="scroll"&&s.hideScrollbar;
  const shadow=shadowCSS(s); const flt=s.blur?`blur(${s.blur}px)`:"none";
  const isHiddenGroup=node.visible===false;

  const d=node.data||{};
  const preview=previewData?.[node.id];
  let resolvedData=null;
  if(d.enabled){
    if(d.mode==="static") resolvedData=d.staticType==="array"?d.staticArray:d.staticJSON;
    else if(d.mode==="globalSource") resolvedData=(globalSourceStore&&d.sourceId)?globalSourceStore[d.sourceId]:null;
    else resolvedData=preview??dataCtx;
  }
  if(Array.isArray(resolvedData)){
    resolvedData=applyListFunctions(resolvedData,d.listFn,runtimeVars);
  }
  const childCtx=(d.enabled&&Array.isArray(resolvedData)&&!d.repeat&&resolvedData.length>0)
    ?resolvedData[0]
    :(d.enabled&&!Array.isArray(resolvedData)&&resolvedData!==null)
      ?resolvedData
      :dataCtx;

  const rc=(ctxItem)=>node.children.map(child=>{
    const cp=[...myPath,child.id];
    const cs=selPath&&selPath.length===cp.length&&cp.every((id,i)=>selPath[i]===id);
    if(child.type==="group") return<GroupView key={child.id} node={child} myPath={cp} selPath={selPath} onSelect={onSelect} onDragStart={onDragStart} onResizeStart={onResizeStart} dataCtx={ctxItem} previewData={previewData} runtimeVars={runtimeVars} onVarChange={onVarChange} globalSourceStore={globalSourceStore}/>;
    return<LeafView key={child.id} node={child} selected={cs} onMouseDown={e=>{onSelect(cp);onDragStart(e,cp,child.styles.x,child.styles.y);}} onResizeDown={(e,hid)=>onResizeStart(e,cp,hid)} dataCtx={ctxItem} runtimeVars={runtimeVars} onVarChange={onVarChange} globalSourceStore={globalSourceStore}/>;
  });

  const groupBgData=d.enabled&&!d.repeat&&resolvedData&&!Array.isArray(resolvedData)?resolvedData:null;
  const baseStyle=(ox,oy,opMul=1,outline,data=null)=>({
    position:"absolute",left:s.x+ox,top:s.y+oy,width:s.width,height:s.height,
    background:bgCSS(s,data),borderRadius:s.borderRadius||0,border:s.borderWidth?`${s.borderWidth}px solid ${s.borderColor}`:"none",
    opacity:(s.opacity??100)/100*opMul*(isHiddenGroup?0.3:1),zIndex:s.zIndex,overflow:overflowCSS,
    scrollbarWidth:hideScrollbar?"none":"auto",msOverflowStyle:hideScrollbar?"none":"auto",
    boxShadow:shadow,filter:flt,outline:outline||"none",outlineOffset:2,
    cursor:"move",userSelect:"none",boxSizing:"border-box",animation:animationCSS(s),
  });

  if(d.enabled&&d.repeat&&Array.isArray(resolvedData)&&resolvedData.length>0){
    return<>{resolvedData.map((item,idx)=>{
      let ox=0,oy=0;
      if(d.layout==="column")oy=idx*(s.height+(d.rowGap||8));
      else if(d.layout==="row")ox=idx*(s.width+(d.colGap||8));
      else{const col=idx%(d.columns||2);const row=Math.floor(idx/(d.columns||2));ox=col*(s.width+(d.colGap||8));oy=row*(s.height+(d.rowGap||8));}
      const isMain=idx===0;
      return<div key={idx} className={hideScrollbar?"kiosk-hs":undefined}
        onMouseDown={isMain?e=>{e.stopPropagation();onSelect(myPath);onDragStart(e,myPath,s.x,s.y);}:undefined}
        style={baseStyle(ox,oy,isMain?1:0.75,isMain&&isSel?"2px solid #f59e0b":undefined,item)}>
        {!isMain&&<div style={{position:"absolute",top:2,right:4,fontSize:7,color:T.yellow,background:"rgba(0,0,0,0.7)",padding:"1px 3px",borderRadius:2,zIndex:9,pointerEvents:"none"}}>#{idx+1}</div>}
        {rc(item)}
        {isMain&&isSel&&<ResizeHandles w={s.width} h={s.height} onDown={(e,hid)=>onResizeStart(e,myPath,hid)}/>}
      </div>;
    })}</>;
  }

  const ghosts=d.enabled&&d.repeat&&(!Array.isArray(resolvedData)||!resolvedData.length)?[1,2]:[];
  return<>
    <div className={hideScrollbar?"kiosk-hs":undefined}
      onMouseDown={e=>{e.stopPropagation();onSelect(myPath);onDragStart(e,myPath,s.x,s.y);}}
      style={baseStyle(0,0,1,isSel?"2px solid #f59e0b":isAnc?"1px dashed #f59e0b66":undefined,groupBgData)}>
      {isSel&&<div style={{position:"absolute",top:-16,left:0,fontSize:8,color:preview!=null?T.green:T.yellow,whiteSpace:"nowrap",background:"rgba(0,0,0,0.85)",padding:"1px 5px",borderRadius:2,pointerEvents:"none",zIndex:99999}}>
        ⬡ {node.name}{d.enabled&&d.repeat?" 🔁":""}{node.isModal?" 🪟":""}{isHiddenGroup?" 👁‍🗨":""}{preview!=null?" ● preview":""}
      </div>}
      {isHiddenGroup&&!isSel&&<div style={{position:"absolute",top:2,right:2,fontSize:6,color:"#f59e0b",background:"rgba(0,0,0,0.75)",padding:"1px 4px",borderRadius:2,pointerEvents:"none",zIndex:9999,fontWeight:700}}>HIDDEN</div>}
      {rc(childCtx)}
      {isSel&&<ResizeHandles w={s.width} h={s.height} onDown={(e,hid)=>onResizeStart(e,myPath,hid)}/>}
    </div>
    {ghosts.map(idx=>{
      let ox=0,oy=0;
      if(d.layout==="column")oy=idx*(s.height+(d.rowGap||8));
      else if(d.layout==="row")ox=idx*(s.width+(d.colGap||8));
      else{const col=idx%(d.columns||2);const row=Math.floor(idx/(d.columns||2));ox=col*(s.width+(d.colGap||8));oy=row*(s.height+(d.rowGap||8));}
      return<div key={`g${idx}`} style={{position:"absolute",left:s.x+ox,top:s.y+oy,width:s.width,height:s.height,opacity:0.25,pointerEvents:"none",outline:"1px dashed #f59e0b55",borderRadius:s.borderRadius||0,background:bgCSS(s),overflow:"hidden",boxSizing:"border-box",zIndex:s.zIndex}}>
        <div style={{position:"absolute",top:2,right:4,fontSize:7,color:T.yellow,background:"rgba(0,0,0,0.7)",padding:"1px 3px",borderRadius:2}}>#{idx+1}</div>
        {rc({})}
      </div>;
    })}
  </>;
}
